import { createStore } from 'vuex'
import Auth from "./modules/Auth"
import UI from "./modules/UI"
import Users from "./modules/Users"
import Members from "./modules/Members"
import Sales from "./modules/Sales"
import Brands from "./modules/Brands"
import Projects from "./modules/Projects"
import Flows from "./modules/Flows"
import Languages from "./modules/Languages"
import Questionlists from "./modules/Questionlists"
import Questions from "./modules/Questions"
import Sections from "./modules/Sections"
import Suppliers from "./modules/Suppliers"
import Evaluation from "./modules/Evaluation"
import Educationpacks from "./modules/Educationpacks"
import Calculations from "./modules/Calculations"
import Verifications from "./modules/Verifications"
import Mail from "./modules/Mail"
import Certificatetypes from "./modules/Certificatetypes"
import Tickets from "./modules/Tickets"
import AuditSchedules from "./modules/AuditSchedules"
import Audit from "./modules/Audit"
import Country from "./modules/Country"
import DocumentEditor from "./modules/DocumentEditor"
import Preaudits from "./modules/Preaudits"
import CustomResultDisplays from "./modules/CustomResultDisplays"

export default createStore({
  modules: {
    auth: Auth,
    ui: UI,
    users: Users,
    members: Members,
    sales: Sales,
    brands: Brands,
    projects: Projects,
    flows: Flows,
    languages: Languages,
    questionlists: Questionlists,
    questions: Questions,
    sections: Sections,
    suppliers: Suppliers,
    evaluation: Evaluation,    
    educationpacks: Educationpacks,
    calculations: Calculations,
    mail: Mail,
    verifications:Verifications,
    certificatetypes:Certificatetypes,
    tickets:Tickets,
    audit_schedules:AuditSchedules,
    audit:Audit,
    countries:Country,
    document_editor:DocumentEditor,
    preaudits:Preaudits,
    customresultdisplays:CustomResultDisplays,
  }
})
